// Tells when a new frontend has been deployed: the page the server hands
// out loads a bundle other than the one running here. Every build names
// its bundle by its content, so any deploy changes the name.

const BUNDLE = /\/static\/js\/(main\.[\w-]+\.js)/

export const CHECK_INTERVAL = 10 * 60 * 1000
const MIN_GAP = 60 * 1000

export const bundleOf = (html) => BUNDLE.exec(html)?.[1] ?? null

// the bundle this page runs; null on the dev server, which has none
export const runningBundle = (doc = document) =>
  [...doc.scripts].map((s) => bundleOf(s.src)).find(Boolean) ?? null

// check() asks the server, at most once a minute, and calls onUpdate once
// when it has a different bundle. Failed or odd answers (a restart's 502)
// are no news.
export const createUpdateCheck = ({
  current,
  fetchIndex,
  onUpdate,
  now = Date.now,
}) => {
  let last = -Infinity
  let done = !current
  return async () => {
    if (done || now() - last < MIN_GAP) return
    last = now()
    let served
    try {
      served = bundleOf(await fetchIndex())
    } catch {
      return
    }
    if (served && served !== current) {
      done = true
      onUpdate(served)
    }
  }
}

// every ten minutes while the tab is seen, and when it is seen again.
// The cookies go along: on servers with pickable frontends one of them
// says which frontend's page to hand out. Returns a stop function.
export const startUpdateCheck = (
  onUpdate,
  { current = runningBundle() } = {},
) => {
  const check = createUpdateCheck({
    current,
    fetchIndex: () =>
      fetch('/', { cache: 'no-store', credentials: 'same-origin' }).then((r) =>
        r.ok ? r.text() : '',
      ),
    onUpdate,
  })
  const whenSeen = () => {
    if (!document.hidden) check()
  }
  const timer = setInterval(whenSeen, CHECK_INTERVAL)
  document.addEventListener('visibilitychange', whenSeen)
  return () => {
    clearInterval(timer)
    document.removeEventListener('visibilitychange', whenSeen)
  }
}
